module.exports = __webpack_public_path__ + "img/gxlogo8.d496ee0e.png";